var _excluded = ["size", "disabled", "status", "placeholder", "label", "animatedHint", "hasContentLeft", "hasContentRight", "onChange", "onKeyUp"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { forwardRef } from 'react';
import styled, { css } from 'styled-components';
import { inputTypo, inputLabelTypo, inputBackground, inputBackgroundHover, inputBackgroundFocus, inputColor, inputCaretColor, inputPlaceholderColor, inputFocusPlaceholderColor, inputBorder, inputBorderHover, inputBorderFocus, inputBorderRadius, inputBorderWidth, inputLabelColor, inputLabelMarginTop } from '../../../../tokens';
import { sizes, statuses } from './Input.props';
var StyledHint = /*#__PURE__*/styled.span.withConfig({
  componentId: "plasma-web-core__sc-1tv4etd-0"
})(["display:flex;align-items:center;transition:all 0.1s ease-in-out;box-sizing:border-box;position:absolute;top:0;left:0;pointer-events:none;color:", ";"], inputLabelColor);
var StyledLabel = /*#__PURE__*/styled(StyledHint).withConfig({
  componentId: "plasma-web-core__sc-1tv4etd-1"
})(["", " input:focus + &,input:not(:placeholder-shown) + &{", "}"], inputTypo, inputLabelTypo);
var StyledPlaceholder = /*#__PURE__*/styled(StyledHint).withConfig({
  componentId: "plasma-web-core__sc-1tv4etd-2"
})(["", " input:placeholder-shown + &{", "}input:focus + &{color:", ";}"], inputLabelTypo, inputTypo, inputFocusPlaceholderColor);

var getPadding = function getPadding(paddingTop, paddingBottom, paddingLeft, paddingRight, paddingY, paddingX) {
  switch (true) {
    case paddingTop !== paddingBottom && paddingLeft !== paddingRight:
      return "".concat(paddingTop, " ").concat(paddingRight, " ").concat(paddingBottom, " ").concat(paddingLeft);

    case paddingTop !== paddingBottom:
      return "".concat(paddingTop, " ").concat(paddingX, " ").concat(paddingBottom);

    case paddingLeft !== paddingRight:
      return "".concat(paddingY, " ").concat(paddingRight, " ").concat(paddingY, " ").concat(paddingLeft);

    default:
      return "".concat(paddingY, " ").concat(paddingX);
  }
};

var applySizes = function applySizes() {
  return function (_ref) {
    var $size = _ref.$size,
        $hasHint = _ref.$hasHint,
        $hasContentLeft = _ref.$hasContentLeft,
        $hasContentRight = _ref.$hasContentRight,
        $animatedHint = _ref.$animatedHint;
    var _sizes$$size = sizes[$size],
        height = _sizes$$size.height,
        paddingY = _sizes$$size.paddingY,
        paddingX = _sizes$$size.paddingX,
        hasLabelPaddingTop = _sizes$$size.hasLabelPaddingTop,
        hasContentPaddingLeft = _sizes$$size.hasContentPaddingLeft,
        hasContentPaddingRight = _sizes$$size.hasContentPaddingRight,
        hasLabelPaddingBottom = _sizes$$size.hasLabelPaddingBottom;
    var paddingTop = $hasHint ? hasLabelPaddingTop : paddingY;
    var paddingBottom = $hasHint ? hasLabelPaddingBottom : paddingY;
    var paddingLeft = $hasContentLeft ? hasContentPaddingLeft : paddingX;
    var paddingRight = $hasContentRight ? hasContentPaddingRight : paddingX;
    var padding = getPadding(paddingTop, paddingBottom, paddingLeft, paddingRight, paddingY, paddingX);
    return css(["height:", ";padding:", ";", " & + ", "{height:", ";padding:", " ", " ", " ", ";}&:focus + ", ",&:not(:placeholder-shown) + ", ",&:not(:placeholder-shown) + ", "{height:auto;padding-top:", ";}"], height, padding, $animatedHint === 'placeholder' && css(["&:placeholder-shown{padding-top:", ";padding-bottom:", ";}"], paddingY, paddingY), StyledHint, height, paddingY, paddingLeft, paddingY, paddingRight, StyledLabel, StyledLabel, StyledPlaceholder, inputLabelMarginTop);
  };
};

var StyledInput = /*#__PURE__*/styled.input.withConfig({
  componentId: "plasma-web-core__sc-1tv4etd-3"
})(["", " ", " -webkit-appearance:none;box-sizing:border-box;width:100%;background-color:", ";color:", ";caret-color:", ";border:0 none;border-radius:", ";box-shadow:inset 0 0 0 ", " ", ";transition:box-shadow 0.1s ease-in,background-color 0.1s ease-in,color 0.1s ease-in;&:hover{background-color:", ";box-shadow:inset 0 0 0 ", " ", ";}&:disabled{box-shadow:inset 0 0 0 ", " ", ";cursor:inherit;}&::placeholder{color:", ";}", " &:focus,&:hover:focus{background-color:", ";box-shadow:inset 0 0 0 ", " ", ";outline:0 none;}&:focus::placeholder{color:", ";}", " ", ""], applySizes, inputTypo, inputBackground, inputColor, inputCaretColor, inputBorderRadius, inputBorderWidth, inputBorder, inputBackgroundHover, inputBorderWidth, inputBorderHover, inputBorderWidth, inputBorder, inputPlaceholderColor, function (_ref2) {
  var $status = _ref2.$status;
  return $status && statuses[$status];
}, inputBackgroundFocus, inputBorderWidth, inputBorderFocus, inputFocusPlaceholderColor, function (_ref3) {
  var $animatedHint = _ref3.$animatedHint;
  return $animatedHint === 'placeholder' && css(["&::placeholder,&:focus::placeholder{color:transparent;}"]);
}, function (_ref4) {
  var $hasLabel = _ref4.$hasHint;
  return $hasLabel && css(["&::placeholder{color:transparent;}"]);
});

var InputPlaceLabel = function InputPlaceLabel(_ref5) {
  var animatedHint = _ref5.animatedHint,
      placeholder = _ref5.placeholder,
      label = _ref5.label;

  if (animatedHint === 'placeholder' && placeholder) {
    return /*#__PURE__*/React.createElement(StyledPlaceholder, null, placeholder);
  }

  if (animatedHint === 'label' && label) {
    return /*#__PURE__*/React.createElement(StyledLabel, null, label);
  }

  return null;
};
/**
 * Поле ввода текста без подсказки и лейбла.
 * @private
 */
// eslint-disable-next-line prefer-arrow-callback


export var Input = /*#__PURE__*/forwardRef(function Input(_ref6, ref) {
  var _ref6$size = _ref6.size,
      size = _ref6$size === void 0 ? 'l' : _ref6$size,
      disabled = _ref6.disabled,
      status = _ref6.status,
      placeholder = _ref6.placeholder,
      label = _ref6.label,
      animatedHint = _ref6.animatedHint,
      hasContentLeft = _ref6.hasContentLeft,
      hasContentRight = _ref6.hasContentRight,
      onChange = _ref6.onChange,
      onKeyUp = _ref6.onKeyUp,
      rest = _objectWithoutProperties(_ref6, _excluded);

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(StyledInput, _extends({
    ref: ref,
    disabled: disabled,
    placeholder: placeholder,
    $size: size,
    $status: status,
    $hasHint: animatedHint && Boolean(label || placeholder),
    $hasContentLeft: hasContentLeft,
    $hasContentRight: hasContentRight,
    $animatedHint: animatedHint,
    onChange: onChange,
    onKeyUp: onKeyUp
  }, rest)), size === 'l' && animatedHint && /*#__PURE__*/React.createElement(InputPlaceLabel, {
    animatedHint: animatedHint,
    placeholder: placeholder,
    label: label
  }));
});